/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current state of a user's streak
 * @export
 */
export const StreakStatus = {
    ACTIVE: 'ACTIVE',
    GRACE: 'GRACE',
    FROZEN: 'FROZEN',
    PAUSED: 'PAUSED',
    BROKEN: 'BROKEN',
    COMPLETED: 'COMPLETED'
} as const;
export type StreakStatus = typeof StreakStatus[keyof typeof StreakStatus];


export function instanceOfStreakStatus(value: any): boolean {
    for (const key in StreakStatus) {
        if (Object.prototype.hasOwnProperty.call(StreakStatus, key)) {
            if (StreakStatus[key as keyof typeof StreakStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreakStatusFromJSON(json: any): StreakStatus {
    return StreakStatusFromJSONTyped(json, false);
}

export function StreakStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakStatus {
    return json as StreakStatus;
}

export function StreakStatusToJSON(value?: StreakStatus | null): any {
    return value as any;
}

export function StreakStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): StreakStatus {
    return value as StreakStatus;
}

